export const stateList = (state, type) =>
	state[type]
		?.filter((item) => item.id !== undefined)
		?.map(({ id, sorting }) => ({ id, sorting }));
